import { makePostRequest } from 'lib/axios';

const setPasswordFromInvite = async (payload: {
  token: string;
  password: string;
}): Promise<any> => {
  const url = `/auth/set-password-from-invite`;
  const response = await makePostRequest(url, payload);
  return response.data;
};

export default setPasswordFromInvite;
